// /admin/monitor-externo — status Supabase + Cloudflare + configuración de notificaciones WA
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import AdminLayout from '../../components/AdminLayout'
import { supabase } from '../../lib/supabase'
import { SupabaseLogo, CloudflareLogoSimple, RefreshIcon } from '../../components/StatusServiceLogo'

const SERVICIOS = [
  { key: 'supabase',   label: 'Supabase',   url: 'https://status.supabase.com',     Logo: SupabaseLogo },
  { key: 'cloudflare', label: 'Cloudflare', url: 'https://www.cloudflarestatus.com', Logo: CloudflareLogoSimple },
]

const COLOR_POR_INDICATOR = {
  none:         { bg: '#D1FAE5', border: '#16A34A', label: 'Todo OK', emoji: '✅' },
  minor:        { bg: '#FEF3C7', border: '#D97706', label: 'Issue menor', emoji: '⚠️' },
  major:        { bg: '#FECACA', border: '#DC2626', label: 'Issue mayor', emoji: '🔴' },
  critical:     { bg: '#FCA5A5', border: '#991B1B', label: 'Caída crítica', emoji: '🚨' },
  maintenance:  { bg: '#DBEAFE', border: '#2563EB', label: 'Mantenimiento', emoji: '🔧' },
  unknown:      { bg: '#F1F5F9', border: '#94A3B8', label: 'Sin datos aún', emoji: '❔' },
}

export default function MonitorExterno() {
  const [estados, setEstados] = useState({})    // { supabase: {indicator, description, ts}, cloudflare: ... }
  const [phones, setPhones] = useState([])
  const [nuevoPhone, setNuevoPhone] = useState('')
  const [chequeando, setChequeando] = useState(false)
  const [msg, setMsg] = useState(null)
  const [history, setHistory] = useState([])

  useEffect(() => { load() }, [])

  async function load() {
    // Últimos estados por servicio (el último log de cada)
    const { data: logs } = await supabase
      .from('monitor_externos_log')
      .select('servicio, indicator, description, incidents_activos, created_at, notificado')
      .order('created_at', { ascending: false })
      .limit(40)
    const ultimoPorServicio = {}
    for (const l of (logs || [])) {
      if (!ultimoPorServicio[l.servicio]) ultimoPorServicio[l.servicio] = l
    }
    setEstados(ultimoPorServicio)
    setHistory(logs || [])

    const { data: cfg } = await supabase.from('app_config').select('value').eq('key', 'monitor_notify_phones').single()
    // app_config.value es text → parsear
    let phonesParsed = []
    try {
      const raw = cfg?.value
      const v = typeof raw === 'string' ? JSON.parse(raw) : raw
      if (Array.isArray(v)) phonesParsed = v
    } catch (_) { /* ignorar */ }
    setPhones(phonesParsed)
  }

  async function chequearAhora() {
    setChequeando(true); setMsg(null)
    try {
      const { data, error } = await supabase.functions.invoke('monitor-externos', { body: {} })
      if (error) throw error
      setMsg({ ok: true, txt: 'Chequeo OK. ' + (data?.cambios?.length || 0) + ' cambio(s) detectado(s).' })
      await load()
    } catch (e) {
      setMsg({ ok: false, txt: 'Error: ' + e.message })
    } finally {
      setChequeando(false)
      setTimeout(() => setMsg(null), 4000)
    }
  }

  async function guardarPhones(nuevoArr) {
    const { error } = await supabase
      .from('app_config')
      .upsert({ key: 'monitor_notify_phones', value: JSON.stringify(nuevoArr) }, { onConflict: 'key' })
    if (error) { alert('Error: ' + error.message); return }
    setPhones(nuevoArr)
  }

  function agregarPhone() {
    const cleaned = nuevoPhone.replace(/[^0-9]/g, '')
    if (cleaned.length < 9) { alert('Teléfono inválido (mínimo 9 dígitos)'); return }
    const final = cleaned.startsWith('598') ? cleaned : '598' + cleaned.replace(/^0/, '')
    if (phones.includes(final)) { alert('Ese número ya está'); return }
    guardarPhones([...phones, final])
    setNuevoPhone('')
  }

  function quitarPhone(p) {
    guardarPhones(phones.filter(x => x !== p))
  }

  return (
    <AdminLayout>
      <div className="page">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h1>Monitor servicios externos</h1>
            <p className="lead">Estado de Supabase y Cloudflare + notificaciones WA cuando hay incidentes.</p>
          </div>
          <Link to="/admin/infraestructura" className="btn ghost">← Volver a Infraestructura</Link>
        </div>

        {/* Cards de estado */}
        <div className="cards-grid" style={{ marginTop: 18 }}>
          {SERVICIOS.map(s => {
            const e = estados[s.key]
            const ind = e?.indicator || 'unknown'
            const c = COLOR_POR_INDICATOR[ind] || COLOR_POR_INDICATOR.unknown
            return (
              <div key={s.key} className="card" style={{ background: c.bg, borderLeft: '4px solid ' + c.border }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <span style={{ fontSize: 32 }}>{c.emoji}</span>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ margin: '0 0 4px', fontSize: 18, display: 'flex', alignItems: 'center', gap: 8, letterSpacing: 0.5 }}>
                      <s.Logo size={22} />
                      <span style={{ textTransform: 'uppercase' }}>{s.label}</span>
                    </h3>
                    <div style={{ fontWeight: 700, color: c.border, fontSize: 14 }}>{c.label}</div>
                    {e?.description && e.description !== c.label && (
                      <div style={{ fontSize: 13, color: '#475569', marginTop: 4 }}>{e.description}</div>
                    )}
                    {e?.incidents_activos > 0 && (
                      <div style={{ fontSize: 12, color: '#991B1B', marginTop: 6, fontWeight: 700 }}>
                        {e.incidents_activos} incidente{e.incidents_activos === 1 ? '' : 's'} activo{e.incidents_activos === 1 ? '' : 's'}
                      </div>
                    )}
                    <a href={s.url} target="_blank" rel="noopener noreferrer"
                       style={{ fontSize: 12, color: '#1A3461', textDecoration: 'underline', marginTop: 8, display: 'inline-block' }}>
                      Status page →
                    </a>
                    {e?.created_at && (
                      <div style={{ fontSize: 11, color: '#64748b', marginTop: 6 }}>
                        Último check: {new Date(e.created_at).toLocaleString('es-UY', { hour: '2-digit', minute: '2-digit', day: 'numeric', month: 'short' })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <div style={{ marginTop: 18, display: 'flex', gap: 10 }}>
          <button className="btn primary" onClick={chequearAhora} disabled={chequeando} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <RefreshIcon size={14} />
            {chequeando ? 'Chequeando…' : 'Chequear ahora'}
          </button>
          {msg && (
            <span style={{ fontSize: 13, color: msg.ok ? '#15803D' : '#B91C1C', alignSelf: 'center' }}>{msg.txt}</span>
          )}
          <span style={{ marginLeft: 'auto', fontSize: 12, color: '#64748b', alignSelf: 'center' }}>
            Auto-check cada 10 min via pg_cron.
          </span>
        </div>

        {/* Notificaciones WA */}
        <h2 className="section-head">Notificaciones WhatsApp</h2>
        <div className="card">
          <p style={{ marginTop: 0 }}>
            Teléfonos que reciben WA cuando cambia el estado de Supabase o Cloudflare.
            Si la lista está vacía, no se notifica (igual queda en el log).
          </p>

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
            {phones.length === 0 ? (
              <span style={{ color: '#94A3B8', fontStyle: 'italic' }}>Sin teléfonos configurados</span>
            ) : (
              phones.map(p => (
                <span key={p} style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  background: '#E0F7F9', color: '#0E7490',
                  padding: '6px 10px', borderRadius: 999, fontWeight: 700,
                  fontSize: 13,
                }}>
                  +{p}
                  <button onClick={() => quitarPhone(p)} style={{
                    background: 'transparent', border: 0, cursor: 'pointer',
                    color: '#991B1B', fontWeight: 800, padding: 0, fontSize: 16, lineHeight: 1,
                  }}>×</button>
                </span>
              ))
            )}
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type="tel"
              placeholder="098610001"
              value={nuevoPhone}
              onChange={e => setNuevoPhone(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && agregarPhone()}
              style={{ padding: '8px 12px', border: '1.5px solid #E2E8F0', borderRadius: 6, fontFamily: 'inherit' }}
            />
            <button className="btn" onClick={agregarPhone}>+ Agregar</button>
          </div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 6 }}>
            Formato Uruguay: 098XXXXXX (se prefija 598 automáticamente).
          </div>
        </div>

        {/* Historial */}
        <h2 className="section-head">Historial reciente</h2>
        <div className="card">
          {history.length === 0 ? (
            <p style={{ color: '#94A3B8' }}>Sin chequeos todavía. Tocá "Chequear ahora" para hacer el primero.</p>
          ) : (
            <table style={{ width: '100%' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #E2E8F0' }}>
                  <th style={th}>Cuándo</th>
                  <th style={th}>Servicio</th>
                  <th style={th}>Estado</th>
                  <th style={th}>Incidentes</th>
                  <th style={th}>Notificado</th>
                </tr>
              </thead>
              <tbody>
                {history.map(h => {
                  const c = COLOR_POR_INDICATOR[h.indicator] || COLOR_POR_INDICATOR.unknown
                  return (
                    <tr key={h.servicio + h.created_at} style={{ borderBottom: '1px solid #F1F5F9' }}>
                      <td style={td}>{new Date(h.created_at).toLocaleString('es-UY', { hour: '2-digit', minute: '2-digit', day: 'numeric', month: 'short' })}</td>
                      <td style={td}><strong>{h.servicio}</strong></td>
                      <td style={td}>
                        <span style={{
                          padding: '2px 8px', borderRadius: 999,
                          fontSize: 11, fontWeight: 800,
                          background: c.bg, color: c.border,
                        }}>{c.emoji} {h.indicator}</span>
                      </td>
                      <td style={td}>{h.incidents_activos || '—'}</td>
                      <td style={td}>{h.notificado ? '✓' : '—'}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AdminLayout>
  )
}

const th = { textAlign: 'left', padding: '10px 12px', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.06em' }
const td = { padding: '10px 12px', fontSize: 13 }
